import { render, staticRenderFns } from "./uploadAppendix.vue?vue&type=template&id=097881ca&scoped=true"
import script from "./uploadAppendix.vue?vue&type=script&lang=js"
export * from "./uploadAppendix.vue?vue&type=script&lang=js"
import style0 from "./uploadAppendix.vue?vue&type=style&index=0&id=097881ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097881ca",
  null
  
)

export default component.exports